import ApiHelper from "~/helpers/api-helper";

export default class TravelPackService {

	public static get($axios, id) {
		return $axios.$get(`/public-travel_pack/${id}`);
	}

	public static getSelectorList($axios, country_id = null) {
		return $axios.$get(`/travel/filter?status_id=1&country_id=` + country_id);
	}

	public static list($axios, pagination, filters, order) {
		const params = ApiHelper.setQueryParams(pagination, filters);
		params.append('sort', order);
		return $axios.$get("/public-travel_pack", { params: params });
	}
}
